"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7340],{

/***/ "./src/components/Landing/AboutIqgpt.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Landing_AboutIqgpt; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js + 1 modules
var chakra_ui_icons_esm = __webpack_require__("./node_modules/@chakra-ui/icons/dist/chakra-ui-icons.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./src/components/Elements/index.ts + 11 modules
var Elements = __webpack_require__("./src/components/Elements/index.ts");
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 23 modules
var esm = __webpack_require__("./node_modules/next-i18next/dist/esm/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/node_modules/@chakra-ui/color-mode/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/system/node_modules/@chakra-ui/color-mode/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__("./node_modules/next/image.js");
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/Elements/Image/AboutGPTMockup.tsx




const AboutGPTMockup = (param)=>{
    let { bg , w , h  } = param;
    const mockup = (0,dist_index_esm/* useColorModeValue */.ff)(bg.light, bg.dark);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        src: mockup,
        alt: "iqgpt-mockup",
        width: w,
        height: h
    });
};
/* harmony default export */ var Image_AboutGPTMockup = (AboutGPTMockup);

// EXTERNAL MODULE: ./src/components/Elements/LinkElements/LinkWrapper.tsx
var LinkWrapper = __webpack_require__("./src/components/Elements/LinkElements/LinkWrapper.tsx");
;// CONCATENATED MODULE: ./src/components/Landing/AboutIqgpt.tsx








const AboutIqgpt = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)("home");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        px: {
            base: 6,
            md: 8
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
            align: {
                base: "center"
            },
            gap: {
                base: 2,
                lg: 6
            },
            pt: {
                base: 5
            },
            maxW: "1290px",
            rounded: "12px",
            bgColor: "aboutIqgptInfoBg",
            mb: {
                base: 0,
                md: 255,
                lg: 375
            },
            mx: "auto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                    spacing: 2,
                    rounded: "16px",
                    py: "4px",
                    pl: "4px",
                    pr: "10px",
                    color: "brandLinkColor",
                    bgColor: "aboutIqgptInfoBg",
                    mixBlendMode: "multiply",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                            py: "2px",
                            px: "10px",
                            bgColor: "white",
                            rounded: "3xl",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontSize: "14px",
                                children: t("IQGPTHeading1")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                            spacing: 1,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                    fontSize: {
                                        base: "14px",
                                        md: "16px"
                                    },
                                    children: t("IQGPTHeading2")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* LinkWrapper */.g, {
                                    href: "https://iqgpt.com/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                        as: "a",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icons_esm/* ArrowForwardIcon */.mr, {})
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* VStack */.gC, {
                    pb: {
                        md: "250"
                    },
                    textAlign: "center",
                    align: {
                        base: "center"
                    },
                    position: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HStack */.Ug, {
                            px: {
                                base: 3
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                fontWeight: "600",
                                maxW: {
                                    md: "400",
                                    lg: "900"
                                },
                                lineHeight: {
                                    base: "32px",
                                    md: "40px"
                                },
                                textAlign: "center",
                                fontSize: {
                                    base: "24px",
                                    md: "30px",
                                    lg: "36px"
                                },
                                color: "gray.800",
                                children: t("IQGPTHeading3")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            pb: {
                                base: "10px",
                                lg: "40px"
                            },
                            px: {
                                base: 3
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                maxW: {
                                    md: "588px",
                                    lg: "910px"
                                },
                                color: "aboutIqgptDesc",
                                fontSize: {
                                    base: "14px",
                                    md: "16px"
                                },
                                children: "".concat(t("aboutIQGPTBody"))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* HStack */.Ug, {
                            gap: 4,
                            pb: "70px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* LinkButton */.Qj, {
                                    href: "https://iqgpt.com/",
                                    size: "lg",
                                    variant: "solid",
                                    px: {
                                        base: 5
                                    },
                                    fontSize: "12px",
                                    fontWeight: "semibold",
                                    children: t("IQGPTBtn1")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Elements/* LinkButton */.Qj, {
                                    href: "https://iq.wiki/wiki/iq",
                                    size: "lg",
                                    px: {
                                        base: 5
                                    },
                                    fontSize: "12px",
                                    bgColor: "white",
                                    color: "gray.700",
                                    _hover: {
                                        bgColor: "gray.200"
                                    },
                                    fontWeight: "semibold",
                                    children: t("IQGPTBtn2")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            display: {
                                base: "none",
                                lg: "inherit"
                            },
                            position: "absolute",
                            bottom: "-75%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_AboutGPTMockup, {
                                bg: {
                                    light: "/images/mockups/iqgpt-mockup-xl.png",
                                    dark: "/images/mockups/iqgpt-mockup-dark-xl.png"
                                },
                                w: 1020,
                                h: 708
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            display: {
                                base: "none",
                                md: "inherit",
                                lg: "none"
                            },
                            position: "absolute",
                            bottom: "-55%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_AboutGPTMockup, {
                                bg: {
                                    light: "/images/mockups/mockup-md.png",
                                    dark: "/images/mockups/mockup-md-dark.png"
                                },
                                w: 570,
                                h: 548
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            display: {
                                md: "none"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_AboutGPTMockup, {
                                bg: {
                                    light: "/images/mockups/mockup-base.png",
                                    dark: "/images/mockups/mockup-base-dark.png"
                                },
                                w: 500,
                                h: 360
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Landing_AboutIqgpt = (AboutIqgpt);


/***/ })

}]);